export function numberWithCommas(x: number | string = 0): string {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
